import React from 'react'
import styled from 'react-emotion'
import AutogrowingTextarea from 'components/AutogrowingTextarea'
import { Icon } from 'shared/ui'
import { propFunc } from 'util/functions'
import { ENTER, ESCAPE } from 'constants/keys'

import themeVars from 'ui_theme/site/globals/site.variables'

const EditableSubjectContainer = styled('div')`
  display: flex;
  align-items: baseline;

  position: relative;
  color: #02a2af;
  :after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -4px;
    display: block;
    height: 1px;
    background-color: currentColor;
  }
`

const Input = styled(AutogrowingTextarea)`
  font-family: inherit;
  color: inherit;
  margin: 0;
  padding: 0;
  padding-bottom: 2px;
  border: 0;
  outline: 0;
  width: 100%;
  resize: none;
  font-size: ${themeVars.big};
  font-weight: ${themeVars.bold};
  line-height: 1.333;
`

export default class EditableSubjectEditingState extends React.PureComponent {
  handleKeyDown = e => {
    const {
      doUpdateTitle,
      doStopEditingTicketTitle,
      ticket: { id: ticketId },
    } = this.props
    if (e.keyCode === ENTER) doUpdateTitle(ticketId)
    if (e.keyCode === ESCAPE) doStopEditingTicketTitle(ticketId)
  }

  handleInput = e => {
    const input = e.target
    this.props.doTicketTitleDraftChanged(input.value)
  }

  render() {
    const { ticket, doUpdateTitle, doStopEditingTicketTitle } = this.props

    return (
      <EditableSubjectContainer>
        <Input
          autoFocus
          defaultValue={ticket.title}
          spellCheck="false"
          autoCorrect="off"
          autoCapitalize="off"
          onBlur={propFunc(doStopEditingTicketTitle, ticket.id)}
          onInput={this.handleInput}
          onKeyDown={this.handleKeyDown}
        />
        <Icon
          name="keyboard-return"
          size="large"
          onClick={propFunc(doUpdateTitle, ticket.id)}
        />
      </EditableSubjectContainer>
    )
  }
}
